import routes from "./routes";
import store from "./store";

export default {
  install(Vue, { store: rootStore, router }) {
    router.addRoutes(routes);
    rootStore.registerModule("auth", store);
  }
};
